import * as config from "./config";

// 获取订单不同状态数量
export const getOrderCount = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/order/getOrderCount';
// 获取订单列表
export const getMyOrder = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/order/getMyOrder';
// 获取订单详细信息
export const getOrderDetail = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/order/myOrderDetail';
// 支付界面订单支付
export const payOrder = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/order/payOrder';
// 买家已知晓
export const orderAlready = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/order/already/';
// 卖家批量添加子订单-商品价格
export const goodsOrderItemPriceSellerSetPrice = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/goodsOrderItemPrice/sellerSetPrice';
// 卖家批量重设子订单-商品价格
export const goodsOrderItemPriceSellerResetPrice = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/goodsOrderItemPrice/sellerResetPrice';
// 买家确认-商品价格信息
export const goodsOrderItemPriceBuyerConfirm = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/goodsOrderItemPrice/buyerConfirm';
// 取消订单
export const closeOrder = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/order/closeOrder';
// 支付界面查询
export const getMergerOrder = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/order/getMergerOrder';
// cpeos商品生成订单
export const addOrderAndShowOrder = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/order/addOrderAndShowOrder';


// 获取用户收藏列表
export const getCollect = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/collect/page';
// 删除收藏列表
export const collectDelete = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/collect/deleteByCollectId';


// 获取用户关注列表
export const getFocus = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/focus/page';

// 取消关注
export const deleteByFocusId = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/focus/deleteByFocusId';

// 添加评论
export const commentAdd = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/comment/add';
// 获取订单项评论
export const getComment = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/comment';


// 获取用户关注列表
export const getdemandpage = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/demand/page';

// 需求变更为发布状态-个人中心
export const demandpush = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/demand/push/';
// 需求变更为发布取消状态-个人中心
export const demandcancel = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/demand/cancel/';
// 需求发布详情-个人中心
export const demandView = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/demand/';
// 需求发布编辑-个人中心
export const demandupdate = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/demand/update';

// 获取用户的科学数据收藏记录
export const getUserList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/bookmark/userList';
// 获取用户的科学数据下载记录
export const getUserDownList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/science/dataInfoDownload/userList';
//科学目录下载申请列表
export const catalogueReviewList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/catalogueReview/userList';
